/**
 * @module common/DualAxis/fields/AxisRangeField
 * @description 受控 Y 轴范围开关（对齐 YAxisRangeSwitch 布局）
 */

import React, { useState } from 'react';
import { useIntl } from 'umi';
import { Bubble, Switch } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';

interface IAxisRangeFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

const AxisRangeField: React.FC<IAxisRangeFieldProps> = ({
  value,
  onChange,
  className = '',
}) => {
  const { formatMessage } = useIntl();
  const [isIconHover, setIsIconHover] = useState(false);

  return (
    <div className={`dbl-chart-setting-row ${className}`}>
      <div className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_yaxis_range_title' })}
        <Bubble
          dark
          placement="top-end"
          placementOffset={[18, 10]}
          content={formatMessage({ id: 'dbl_chart_yaxis_range_tip' })}
        >
          <span
            className="dbl-dual-axis-field__range-info"
            onMouseEnter={() => setIsIconHover(true)}
            onMouseLeave={() => setIsIconHover(false)}
          >
            <SvgIcon
              className="port-icon"
              type={isIconHover ? 'alert-circle-action' : 'alert-circle-m'}
            />
          </span>
        </Bubble>
      </div>
      <Switch value={value} onChange={onChange} />
    </div>
  );
};

export default React.memo(AxisRangeField);
